// /src/components/SEO.js

import { useEffect } from 'react';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  canonicalUrl, 
  ogImage,
  ogType = 'website',
  noIndex = false,
  structuredData = null
}) => {
  useEffect(() => {
    // Update document title
    if (title) {
      document.title = title;
    }

    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription && description) {
      metaDescription.setAttribute('content', description);
    }

    // Update keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords && keywords) {
      metaKeywords.setAttribute('content', keywords);
    }

    // Update canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalUrl) {
      if (!canonicalLink) {
        canonicalLink = document.createElement('link');
        canonicalLink.setAttribute('rel', 'canonical');
        document.head.appendChild(canonicalLink);
      }
      canonicalLink.setAttribute('href', canonicalUrl);
    }

    // Update Open Graph tags
    const updateOGTag = (property, content) => {
      let ogTag = document.querySelector(`meta[property="${property}"]`);
      if (!ogTag) {
        ogTag = document.createElement('meta');
        ogTag.setAttribute('property', property);
        document.head.appendChild(ogTag);
      }
      ogTag.setAttribute('content', content);
    };

    if (title) updateOGTag('og:title', title);
    if (description) updateOGTag('og:description', description);
    if (canonicalUrl) updateOGTag('og:url', canonicalUrl);
    if (ogImage) updateOGTag('og:image', ogImage);
    updateOGTag('og:type', ogType);
    updateOGTag('og:site_name', 'Gavefinner');
    updateOGTag('og:locale', 'nb_NO');

    // Update Twitter tags
    const updateTwitterTag = (name, content) => {
      let twitterTag = document.querySelector(`meta[name="${name}"]`);
      if (!twitterTag) {
        twitterTag = document.createElement('meta');
        twitterTag.setAttribute('name', name);
        document.head.appendChild(twitterTag);
      }
      twitterTag.setAttribute('content', content);
    };

    if (title) updateTwitterTag('twitter:title', title);
    if (description) updateTwitterTag('twitter:description', description);
    if (ogImage) updateTwitterTag('twitter:image', ogImage);
    updateTwitterTag('twitter:card', 'summary_large_image');

    // Robots meta tag
    const robotsTag = document.querySelector('meta[name="robots"]');
    if (robotsTag) {
      robotsTag.setAttribute('content', noIndex ? 'noindex, nofollow' : 'index, follow');
    } else if (noIndex) {
      const newRobotsTag = document.createElement('meta');
      newRobotsTag.setAttribute('name', 'robots');
      newRobotsTag.setAttribute('content', 'noindex, nofollow');
      document.head.appendChild(newRobotsTag);
    }

    // Structured Data
    if (structuredData) {
      // Remove existing structured data
      const existingLD = document.querySelector('script[type="application/ld+json"][data-dynamic]');
      if (existingLD) {
        existingLD.remove();
      }

      // Add new structured data
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-dynamic', 'true');
      script.textContent = JSON.stringify(structuredData);
      document.head.appendChild(script);
    }

  }, [title, description, keywords, canonicalUrl, ogImage, ogType, noIndex, structuredData]);

  return null;
};

export default SEO;